import { ISalePageDetailResponseGachaReward } from '@/api/types';
import { Element } from '@vuddy/components';
import * as styles from './gachaProbabilityTable.css';

interface IGachaContentProbabilityTableProps {
  isProxy: boolean;
  rewards: ISalePageDetailResponseGachaReward[];
}

export const GachaContentProbabilityTable = ({
  isProxy,
  rewards,
}: IGachaContentProbabilityTableProps) => {
  return (
    <Element className={styles.table} color="whitePrimary">
      <Element
        className={styles.tableHeaderGroup}
        typography="captionBase"
        backgroundColor="whiteTertiary">
        <div className={styles.tableCell}>종류</div>
        <div className={styles.tableCell}>등급</div>
        <div className={styles.tableCell}>확률(%)</div>
        <div className={styles.tableCell}>리워드</div>
      </Element>
      <Element
        className={styles.tableRowGroup}
        typography="captionBaseAccent"
        backgroundColor="whiteQuaternary">
        {rewards.map((reward, i) => (
          <div
            className={styles.tableRow}
            key={reward.grade + reward.probability + i}>
            <div className={styles.tableCell}>디지털{i + 1}</div>
            <div className={styles.tableCell}>{reward.grade}</div>
            <div className={styles.tableCell}>
              {isProxy ? reward.proxyProbability : reward.probability}%
            </div>
            <div className={styles.tableCell}>
              {reward.hasBonusGifts ? '제공' : '미제공'}
            </div>
          </div>
        ))}
      </Element>
    </Element>
  );
};
